module.exports = __webpack_public_path__ + "static/media/logo.27d09e88.png";